import React, { useState } from "react";
import { GALLERY_IMAGES } from "../constants";
import { X, ZoomIn, Camera } from "lucide-react";

export const Gallery: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const activeImg = GALLERY_IMAGES.find((img) => img.id === selectedImage);

  return (
    <section className="py-16 bg-white" id="gallery">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-giz-primary font-bold tracking-wider uppercase text-sm">
            Dokumentasi
          </span>
          <h2 className="text-3xl font-bold text-gray-900 mt-2">
            Galeri Keseruan
          </h2>
          <p className="text-gray-500 mt-2">
            Intip momen seru pengunjung di GIZ Park dan RIW
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {GALLERY_IMAGES.slice(0, 9).map((image) => (
            <div
              key={image.id}
              className="relative group cursor-pointer overflow-hidden rounded-2xl h-64 shadow-md"
              onClick={() => setSelectedImage(image.id)}
            >
              <img
                src={image.url}
                alt={image.caption}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                <div className="text-center text-white p-4 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <ZoomIn className="w-8 h-8 mx-auto mb-2" />
                  <span className="block font-bold text-sm bg-giz-primary px-2 py-1 rounded mb-1 w-fit mx-auto">
                    {image.category}
                  </span>
                  <p className="text-sm font-medium">{image.caption}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && activeImg && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 animate-fadeIn backdrop-blur-sm">
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-6 text-white hover:text-gray-300 bg-white/10 p-2 rounded-full transition-colors"
          >
            <X className="w-8 h-8" />
          </button>

          <div className="max-w-4xl w-full max-h-[90vh] flex flex-col items-center">
            <img
              src={activeImg.url}
              alt={activeImg.caption}
              className="max-w-full max-h-[80vh] rounded-lg shadow-2xl"
              loading="lazy"
            />
            <div className="mt-4 text-white text-center">
              <h3 className="text-xl font-bold flex items-center justify-center gap-2">
                <Camera className="w-5 h-5 text-giz-primary" />{" "}
                {activeImg.category}
              </h3>
              <p className="text-gray-300 mt-1">{activeImg.caption}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
